import InfiniteScroll from "react-infinite-scroller";
import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { injectIntl } from "react-intl";
import List from "../List/List";
import { intlShape } from "../../shapes";
import {
  apiShape,
  notifierShape,
  withApi,
  withNotifier,
  withBrowser,
  browserShape,
} from "../../context";
import { Row, Column } from "../Grid";
import Loader from "../Loader";
import {
  formatAssetDetails,
  isEmpty,
  isNotEmpty,
  isSomething,
  readLocalStorage,
} from "../../utils";
import ListItemImage from "../List/ListItemImage";
import ListItem from "../List/ListItem";
import { extractAssets } from "../../extractors";

type Props = {
  readonly subscriptionId?: number;
  readonly subscriptionRoute: string;
  readonly intl: intlShape;
  readonly api: apiShape;
  readonly browser: browserShape;
  readonly notifier: notifierShape;
  readonly onTotalAssetsCountChange?: (totalCount: number) => void;
};

export function SubscriptionAssignedAssetsList({
  intl,
  api,
  subscriptionId,
  subscriptionRoute,
  notifier,
  browser,
  onTotalAssetsCountChange,
}: Props) {
  const [assets, setAssets] = useState([]);
  const [pagination, setPagination] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const loadAssignedAssets = async (assetsUrl: $TSFixMe) => {
    try {
      setIsLoading(true);
      const assetInclude = {
        include:
          "product.manufacturer,product.tenant,product.pictures,specifications",
      };
      const response = await api.get(assetsUrl, assetInclude);
      setPagination(response.pagination);
      onTotalAssetsCountChange?.(response.pagination.total_count);
      const newAssets = extractAssets(response);
      setAssets(assets.concat(newAssets));
      setIsLoading(false);
    } catch (error) {
      notifier.showError(api.translateError(error));
    }
  };

  const handleOnClick = (assetId: $TSFixMe) => {
    const rootBackUrl = readLocalStorage("rootBackUrl");
    const redirectUrl =
      // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
      isSomething(rootBackUrl) && !rootBackUrl.endsWith("netilion")
        ? `${rootBackUrl}/assets/${assetId}`
        : `/app/analytics/assets/${assetId}`;
    browser.redirectToExtern(redirectUrl);
  };

  const loadMoreAssignedAssets = async () => {
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    loadAssignedAssets(pagination.next).then();
  };

  React.useEffect(() => {
    /* istanbul ignore next */
    if (isEmpty(assets)) {
      loadAssignedAssets(
        `/${subscriptionRoute}/${subscriptionId}/assets`,
      ).then();
    }
  }, [subscriptionId]);

  const renderItems = () =>
    assets.map((asset) => (
      <ListItem
        key={`asset-item-${(asset as $TSFixMe).id}`}
        id={`asset-item-${(asset as $TSFixMe).id}`}
        image={
          (asset as $TSFixMe).thumbnailUrl ? (
            <ListItemImage pictureUrl={(asset as $TSFixMe).thumbnailUrl} />
          ) : undefined
        }
        icon={(asset as $TSFixMe).thumbnailUrl ? undefined : "icon-eh-device"}
        title={(asset as $TSFixMe).serialNumber}
        description={formatAssetDetails(asset)}
        status={(asset as $TSFixMe).assetStatusName}
        namur={(asset as $TSFixMe).assetStatusCode}
        onClick={() => handleOnClick((asset as $TSFixMe).id)}
      />
    ));

  const showEmptyMessage = () =>
    !isLoading ? (
      <p id="emptyMessage" className="space-after">
        {intl.formatMessage({ id: "subscription.no_assets_assigned" })}
      </p>
    ) : (
      <p />
    );

  return (
    <Loader loading={isLoading}>
      <Row>
        <Column>
          <List id="assigned-assets-list">
            <InfiniteScroll
              initialLoad={false}
              loadMore={loadMoreAssignedAssets}
              // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
              hasMore={isSomething(pagination) && isSomething(pagination.next)}
            >
              {isNotEmpty(assets) ? renderItems() : showEmptyMessage()}
            </InfiniteScroll>
          </List>
        </Column>
      </Row>
    </Loader>
  );
}

export default withRouter(
  // @ts-expect-error TS(2345) FIXME: Argument of type 'FC<WithIntlProps<Readonly<Omit<R... Remove this comment to see the full error message
  injectIntl(
    withBrowser(withNotifier(withApi(SubscriptionAssignedAssetsList))),
  ),
);
